var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsingNoviopus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "61px",
    height: "114px",
    viewBox: "0 0 61 114",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Help-Center",
    transform: "translate(-120.000000, -656.000000)",
    fill: "#FFFFFF",
    stroke: "#5C6169"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sourcing-ill",
    transform: "translate(85.000000, 467.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(56.741119, 278.373427) rotate(58.000000) translate(-56.741119, -278.373427) translate(-37.258881, 207.373427)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.186655,155.633962 C118.723364,117.918239 106.115372,62.474726 103.795052,40.4182491 C102.343407,26.6192178 85.2619771,15.364366 80.4892432,10.2377085 C79.391476,9.05853593 76.4829335,3.80249389 73.9329865,-1.59009177 C71.1243308,-7.52979041 73.5976111,-9.81546136 71.4014913,-11.3824035 C67.1359669,-14.4258759 65.3984726,-13.0077296 62.9507444,-11.6509317 C52.0341918,-5.59978782 69.2206962,12.8158402 65.4212678,14.9202946 C46.9766526,25.1365291 48.6210996,24.4574125 45.7628642,26.7826163 C42.9046288,29.1078201 37.7941499,32.528862 40.1898012,36.0604876 C41.7869021,38.4149047 42.9154089,39.6267482 43.5753216,39.696018 L53.3315687,33.5605687 L43.5753216,39.696018 C42.6895528,41.2637506 42.8982611,43.0024056 44.2014465,44.9119829 C45.5046319,46.8215603 46.8148132,47.897538 48.1319903,48.139916 L59.6597042,42.351616 L48.1319903,48.139916 C48.0557248,49.9198675 48.8611251,51.7268336 50.5481911,53.5608144 C52.2352572,55.3947952 56.0799567,54.4756642 62.0822897,50.8034215 L54.62413,54.8594162 C54.5529521,56.2476322 55.2032387,57.8086971 56.5749898,59.5426108 C57.9467409,61.2765245 59.760453,61.6053731 62.016126,60.5291567 C75.2052158,54.3309801 83.2607891,50.0983521 86.1828461,47.8312727 C89.1049031,45.5641933 90.4604954,43.1992889 90.249623,40.7365593",
    id: "Path-5",
    transform: "translate(93.877739, 71.220092) scale(-1, 1) rotate(-282.000000) translate(-93.877739, -71.220092) "
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsingNoviopus);
export default __webpack_public_path__ + "static/media/usingNoviopus.26f994bfe4e3be17dc29ce090d325b4e.svg";
export { ForwardRef as ReactComponent };